import React, { useState } from 'react';
import { Container, TooltipCircle, TooltipWrap } from './styles';

const ToolTip = ({ text, children, className, color }) => {

    return (
        <TooltipWrap>
            <Container className={className}>
                <span>{text}</span>
                <TooltipCircle color={color}>
                    {children}
                </TooltipCircle >
            </Container>
        </TooltipWrap>
    )
};

export default ToolTip;